import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ClientService } from '../../client/client.service';
import { Client } from '../../client/client';
import { User } from '../../user/user';
import { AuthenticationService } from '../../user/authentication.service';
import { ServiceDashboardService } from './service-dashboard.service';
import { SoftwareService } from 'src/app/software-services/software-service';
import { SoftwareServiceService } from 'src/app/software-services/software-service.service';
import { SoftwareServices } from 'src/app/software-services/software-services.enum';

@Component({
    selector: 'matrix-tools-service-dashboard',
    templateUrl: './service-dashboard.component.html',
    styleUrls: ['./service-dashboard.component.scss'],
    standalone: false
})
export class ServiceDashboardComponent implements OnInit {
  @Input() ClientId: number;
  user: User = null;
  loading: boolean = true;

  constructor(private auth: AuthenticationService,
    public clientService: ClientService,
    private softwareServiceService: SoftwareServiceService,
    public dashboardService: ServiceDashboardService) {
  }

  ngOnInit() {
    // EVERYTHING STARTS HERE!
    this.user = this.auth.getCurrentUser();

    this.clientService.getClients().subscribe((clients: Client[]) => {
      this.clientService.allClients = clients;

      this.softwareServiceService.getSoftwareServices().subscribe((softwareServices: SoftwareService[]) => {
        this.dashboardService.softwareServices = softwareServices;
        this.clientService.allClients.forEach(client => {
          client.softwareServices = [];
          // Populate softwareServices (and flags) based off of softwareServiceIdList
          let softwareServiceIds = client.softwareServiceIdList.split(',');
          softwareServiceIds.forEach(softwareServiceId => {
            let softwareService = this.dashboardService.softwareServices.find(service => service.id === +softwareServiceId);
            client.softwareServices.push(softwareService);
            if (softwareService.tag === SoftwareServices.websiteService) {
              client.isWebsiteEnabled = true;
            }
            if (softwareService.tag === SoftwareServices.seoService) {
              client.isSeoEnabled = true;
            }
            if (softwareService.tag === SoftwareServices.smmService) {
              client.isSmmEnabled = true;
            }
          });
        });

        this.dashboardService.client = this.clientService.allClients.find(client => {
          return client.id === this.ClientId;
        });

        debugger;//jebjebjebjeb
        this.setWebsite();

        // Active the Dashboard UI
        this.loading = false;
      });
    });
  }

  setWebsite(websiteDomain?: string) {
    if (!websiteDomain) {
      this.dashboardService.website = this.dashboardService.client.websites[0];
    } else {
      this.dashboardService.website = this.dashboardService.client.websites.find(website => {
        return website.domain === websiteDomain;
      });
    }
  }

  setMimicClientId(clientId: number) {
    if (!this.user.isEmployee)
      return;

    this.dashboardService.client = this.clientService.allClients.find(client => {
      return client.id === clientId;
    });

    this.dashboardService.website = this.dashboardService.client.websites[0];
  }

  // Used for +/- mimicking
  setMimicClientIndex(clientIndex: number) {
    if (!this.user.isEmployee)
      return;

    this.dashboardService.client = this.clientService.allClients[clientIndex];
    this.dashboardService.website = this.clientService.allClients[clientIndex].websites[0];
  }

  viewPreviousClient() {
    let clientIndex = this.clientService.allClients.indexOf(this.dashboardService.client);
    let prevClientId = clientIndex - 1;
    if (prevClientId < 0) {
      prevClientId = this.clientService.allClients.length - 1;
    }

    this.setMimicClientIndex(prevClientId);
  }

  viewNextClient() {
    let clientIndex = this.clientService.allClients.indexOf(this.dashboardService.client);
    let nextClientId = clientIndex + 1;
    if (nextClientId >= this.clientService.allClients.length) {
      nextClientId = 0;
    }

    this.setMimicClientIndex(nextClientId);
  }

  //jeb todo / or pull favicon from site!!!
  //changeIcon() {
  //}

  //jeb todo
  //changeIndustry() {
  //}

  logOut() {
    this.auth.logout();
  }

  //jeb TODO keyboard also ENTER for all inputs
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') {
      this.viewPreviousClient();
    }

    if (event.key === 'ArrowRight') {
      this.viewNextClient();
    }
  }
}
